import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Section from 'components/Section';
import Checkbox from 'components/Checkbox';

import { FlightEditGeneralInfoDetails_flight$key } from '__generated__/FlightEditGeneralInfoDetails_flight.graphql';

type Props = {
  flight: FlightEditGeneralInfoDetails_flight$key;
};

const FlightEditGeneralInfoDetails: FC<Props> = props => {
  const { updateUrl, priceKey, bookingToken } = useFragment(
    graphql`
      fragment FlightEditGeneralInfoDetails_flight on Flight {
        updateUrl
        priceKey
        bookingToken
      }
    `,
    props.flight
  );

  return (
    <Section id="details" title="Informacija">
      <Stack spacing={4}>
        <FormControlLabel
          label="Pasibaigęs galiojimas"
          control={<Checkbox name="expired" />}
        />

        <TextField
          fullWidth
          disabled
          variant="standard"
          value={updateUrl}
          label="Atnaujinimo URL"
        />
        <TextField
          fullWidth
          disabled
          variant="standard"
          value={priceKey}
          label="ID tiekėjo sistemoje"
        />
        <TextField
          fullWidth
          disabled
          variant="standard"
          value={bookingToken}
          label="Booking token"
        />
      </Stack>
    </Section>
  );
};

export default FlightEditGeneralInfoDetails;
